import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";

export default function AuditPage() {
  const [logs, setLogs] = useState([]);
  const [action, setAction] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    api.get("/audit-logs", { params: action ? { action } : {} })
      .then(({data}) => setLogs(data)).finally(() => setLoading(false));
  }, [action]);

  return (
    <div className="p-6 lg:p-8" data-testid="audit-page">
      <div className="mb-6">
        <div className="tiny-label text-violet-400">Audit</div>
        <h1 className="mt-1 text-4xl font-extrabold tracking-tight">Activity log</h1>
      </div>

      <div className="mb-4 flex gap-2 flex-wrap">
        {["", "user.login", "order.create", "order.submit", "order.discount", "order.void_item", "payment.process", "product.create", "branch.create", "table.status_update"].map((a) => (
          <button key={a || "all"} onClick={() => setAction(a)} data-testid={`audit-filter-${a || "all"}`}
                  className={`h-8 px-3 rounded-md text-[11px] font-bold uppercase tracking-wider transition-colors ${
                    action === a ? "bg-violet-600 text-white" : "bg-zinc-900 border border-white/10 text-zinc-400 hover:text-white"
                  }`}>
            {a || "All"}
          </button>
        ))}
      </div>

      <div className="panel-elevated overflow-hidden">
        <table className="w-full text-sm">
          <thead>
            <tr className="text-left tiny-label border-b border-white/10">
              <th className="p-3">Time</th>
              <th className="p-3">Action</th>
              <th className="p-3">Record</th>
              <th className="p-3">User</th>
              <th className="p-3">Details</th>
            </tr>
          </thead>
          <tbody>
            {loading && <tr><td colSpan={5} className="p-6 text-center text-zinc-500">Loading…</td></tr>}
            {!loading && logs.length === 0 && <tr><td colSpan={5} className="p-8 text-center text-zinc-500">No activity yet.</td></tr>}
            {logs.map((l) => (
              <tr key={l.id} className="border-b border-white/5 hover:bg-white/[0.03]" data-testid={`audit-row-${l.id}`}>
                <td className="p-3 text-zinc-500 text-xs whitespace-nowrap">{new Date(l.created_at).toLocaleString("en-PH")}</td>
                <td className="p-3 mono text-violet-300 text-xs">{l.action}</td>
                <td className="p-3 text-zinc-400 text-xs">{l.record_type} · <span className="mono">{l.record_id?.slice(-8)}</span></td>
                <td className="p-3 text-zinc-500 mono text-xs">{l.user_id?.slice(-6) || "system"}</td>
                <td className="p-3 text-zinc-400 text-xs max-w-md truncate">{l.reason || (l.after && JSON.stringify(l.after).slice(0, 120))}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
